var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPayment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.75 0.75C2.08696 0.75 1.45107 1.01339 0.982233 1.48223C0.513392 1.95107 0.25 2.58696 0.25 3.25V4.5H17.75V3.25C17.75 2.58696 17.4866 1.95107 17.0178 1.48223C16.5489 1.01339 15.913 0.75 15.25 0.75H2.75ZM0.25 10.75V5.75H17.75V10.75C17.75 11.413 17.4866 12.0489 17.0178 12.5178C16.5489 12.9866 15.913 13.25 15.25 13.25H2.75C2.08696 13.25 1.45107 12.9866 0.982233 12.5178C0.513392 12.0489 0.25 11.413 0.25 10.75ZM12.125 9.5C11.9592 9.5 11.8003 9.56585 11.6831 9.68306C11.5658 9.80027 11.5 9.95924 11.5 10.125C11.5 10.2908 11.5658 10.4497 11.6831 10.5669C11.8003 10.6842 11.9592 10.75 12.125 10.75H14.625C14.7908 10.75 14.9497 10.6842 15.0669 10.5669C15.1842 10.4497 15.25 10.2908 15.25 10.125C15.25 9.95924 15.1842 9.80027 15.0669 9.68306C14.9497 9.56585 14.7908 9.5 14.625 9.5H12.125Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPayment);
export default __webpack_public_path__ + "static/media/payment.f715b6b1.svg";
export { ForwardRef as ReactComponent };